import Loader from 'apollo-react/components/Loader';
import MenuButton from 'apollo-react/components/MenuButton';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import ConfirmPublishModal from './ConfirmPublishModal';
import CreateReportModal from './CreateReportModal';
import ExportReportModal from './ExportReportModal';
import ImportReportModal from './ImportReportModal';
import { useTranslation } from '../../custom-hooks/useTranslation';
import { getIsRtlLanguage } from '../../selectors/AuthSelectors';
import {
  getCreateReportData,
  getIsExportPending,
  getIsPowerBIImportModalOpen,
} from '../../selectors/PowerBISelectors';
import { getUITA } from '../../utils/commonUtils';
import { getIsPublishDisabled } from '../../utils/powerBIUtils';

const PowerBIReportsActionsMenu = ({ selectedReports, setSelectedReports }) => {
  const translateString = useTranslation();

  const isRtlLanguage = useSelector(getIsRtlLanguage);
  const isPowerBIImportModalOpen = useSelector(getIsPowerBIImportModalOpen);
  const { isModalOpen } = useSelector(getCreateReportData);
  const isReportExportLoading = useSelector(getIsExportPending);

  const [isConfirmModalOpen, setConfirmModalOpen] = useState(false);
  const [isExportModalOpen, setExportModalOpen] = useState(false);
  const [isLoading, setLoading] = useState(false);

  const manageReportButtons = [
    {
      text: translateString('Export'),
      onClick: () => setExportModalOpen(true),
      disabled: !selectedReports.length,
    },
    {
      text: translateString('Publish'),
      onClick: () => setConfirmModalOpen(true),
      disabled: getIsPublishDisabled(selectedReports),
    },
  ];

  return (
    <>
      <MenuButton
        buttonText={translateString('Manage Report Actions')}
        style={{ marginRight: 10, marginLeft: isRtlLanguage && 10 }}
        menuItems={manageReportButtons}
        ui-ta={getUITA('manage-reports-actions')}
      />
      {isPowerBIImportModalOpen && <ImportReportModal />}
      {isModalOpen && <CreateReportModal />}
      {isExportModalOpen && (
        <ExportReportModal
          onClose={() => setExportModalOpen(false)}
          selectedReports={selectedReports}
          setSelectedReports={setSelectedReports}
        />
      )}
      {isConfirmModalOpen && (
        <ConfirmPublishModal
          onClose={() => setConfirmModalOpen(false)}
          setLoading={setLoading}
          selectedReports={selectedReports}
          setSelectedReports={setSelectedReports}
        />
      )}
      {(isLoading || isReportExportLoading) && <Loader />}
    </>
  );
};

export default PowerBIReportsActionsMenu;
